import React from 'react'

import { Text } from 'components/dataDisplay'

import OrderItemBase from 'compositions/orderItems/OrderItemBase/OrderItemBase'
import OrderProductBase from 'compositions/orderItems/OrderProductBase/OrderProductBase'


type GiftSubscriptionOfferOrderItemProps = {
  className?: string
  data: OrderItems.GiftSubscriptionOffer
}

const GiftSubscriptionOfferOrderItem: React.FunctionComponent<GiftSubscriptionOfferOrderItemProps> = (props) => {
  const { className, data } = props
  const { description, image, priceOfferText, whatYouAreGetting } = data

  if (whatYouAreGetting) {
    return null
  }

  return (
    <OrderItemBase className={className} data-testid="orderGiftSubscriptionOfferProduct">
      <OrderProductBase
        image={image}
        rebrandImage={image}
        name={description}
        priceNode={<Text message={priceOfferText} style="t2" />}
      />
    </OrderItemBase>
  )
}


export default GiftSubscriptionOfferOrderItem
